import CryptoJS from 'crypto-js';
import config from '../config';
import {devPrefix, devSuffix, ecom, uatPrefix} from '../constants/constants';

export const generateRandomString = (length) => {
  return Array.from(Array(length), () => Math.floor(Math.random() * 36).toString(36)).join('');
};

export const base64URL = (string) => {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};

export const isDev = () => (window.location.href.indexOf(devPrefix) > -1) || (window.location.href.indexOf(devSuffix) > -1) ;
export const isUat = () => window.location.href.indexOf(uatPrefix) > -1;
export const isD365 = () => (window.location.href.indexOf(ecom) > -1) && !(window.location.href.indexOf(uatPrefix) > -1);
export const isLocalHost = () => window.location.href.indexOf('localhost') > -1;

export const getLoggingUrl = () => {
  //https://int-dev.jjfoodservice.com/api/analytics
  // https://int-uat.ecom.notprod.jjfoodservice.com/api/analytics
  // https://int.jjfoodservice.com/api/analytics
  return '/api/analytics/'
}

export const getEnvironmentLabel = () => {
  const devOrProd = isDev() ? 'Dev' : 'Prod'
  const d365 = isD365() ? 'D365' : '' ;

  if(isLocalHost()) {
    return 'localhost'
  }

  return `${isUat() ? 'Uat' : devOrProd} ${d365}`
}

export const getTestingUrl = () => {
  return `https://int${isUat() ? uatPrefix : devPrefix}.${(isD365() || isUat()) ? `.${ecom}.${devSuffix}prod` : ''}jjfoodservice.com/${config.basename}${config.defaultPath}`;
};


export const getRedirectUrl = () => {
  const redirect = encodeURIComponent(window.location.pathname);

  if (isLocalHost()) {
    return `${config.basename}/pages/login/local-ad-login?redirect=${redirect}`;
  }

  return `/auth?redirect=${redirect}`;
};


export const isLocalLoginRoute = () => window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('/success') > -1;